<template>
  <ShTabs v-model="activeName">
    <ShTabsPanel label="图书详情" name="bookDesc">
      <div class="bookimg" v-for="item in booksDetail" :key="item.index">
        <template v-for="vtem in item.descImgs" :key="vtem.index">
          <img v-lazy="vtem.url" :alt="vtem.name" />
        </template>
      </div>
    </ShTabsPanel>
    <ShTabsPanel label="考试大纲" name="bookOutLine"
      ><BookOutLine :videoData="booksDetail"
    /></ShTabsPanel>
    <ShTabsPanel label="备考建议" name="bookAdvice"
      ><BookAdvice :videoData="booksDetail"
    /></ShTabsPanel>
  </ShTabs>
</template>

<script>
import { ref } from "vue";
import BookOutLine from "@/views/video-detail/compontents/video-outline.vue";
import BookAdvice from "@/views/video-detail/compontents/video-advice.vue";
export default {
  components: {
    BookOutLine,
    BookAdvice,
  },
  props: {
    booksDetail: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const activeName = ref("bookDesc");
    return { activeName };
  },
};
</script>

<style lang="less" scoped>
.bookimg {
  margin-top: 15px;
}
</style>
